// 3rd Party Libraries
import { combineReducers, createStore } from "redux";

// Creates the Redux store with reducers and middleware
const rootReducer = combineReducers({});

const store = createStore(rootReducer);

export { store };
